import React, { useState } from 'react';
import {
  Button,
  Input,
  Space,
  Typography,
  message,
  Card,
  Descriptions,
  Table,
  Tag,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import { adminBluetoothLowBalanceSmsTest, adminQuerySmsSendDetailsToday } from '../../api';

const { Text, Paragraph } = Typography;

const previewFang = (houseName, roomFang) =>
  [houseName, roomFang].map((s) => String(s || '').trim()).filter(Boolean).join('') || '—';

const smsStatusTagColor = (key) => {
  if (key === 'success') return 'success';
  if (key === 'failed') return 'error';
  if (key === 'waiting') return 'warning';
  return 'default';
};

const BluetoothLowBalanceSmsTest = () => {
  const [phone, setPhone] = useState('');
  const [houseName, setHouseName] = useState('');
  const [roomFang, setRoomFang] = useState('');
  const [templateCode, setTemplateCode] = useState('');
  const [signName, setSignName] = useState('');
  const [sendLoading, setSendLoading] = useState(false);
  const [queryLoading, setQueryLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [list, setList] = useState([]);
  const [queryMsg, setQueryMsg] = useState('');
  const [queryHint, setQueryHint] = useState('');

  const loadToday = async (phoneOverride, bizIdOverride) => {
    const p = String(phoneOverride ?? phone ?? '').trim();
    if (!p) {
      message.warning('请先输入手机号');
      return;
    }
    setQueryLoading(true);
    try {
      const res = await adminQuerySmsSendDetailsToday({
        phone: p,
        biz_id: bizIdOverride != null ? bizIdOverride : result?.biz_id,
      });
      if (res?.success) {
        setList(Array.isArray(res.data?.list) ? res.data.list : []);
        setQueryMsg(res.msg || '');
        setQueryHint(res.data?.hint || '');
      } else {
        setList(Array.isArray(res?.data?.list) ? res.data.list : []);
        setQueryMsg(res?.msg || '查询失败');
        setQueryHint(res?.data?.hint || '');
        message.error(res?.msg || '查询失败');
      }
    } catch (e) {
      setList([]);
      setQueryMsg('');
      message.error(e.response?.data?.msg || e.message || '查询失败');
    } finally {
      setQueryLoading(false);
    }
  };

  const sendTest = async () => {
    const p = String(phone || '').trim();
    if (!p) {
      message.warning('请输入手机号');
      return;
    }
    if (!String(roomFang || '').trim()) {
      message.warning('请输入房间号');
      return;
    }
    setSendLoading(true);
    try {
      const res = await adminBluetoothLowBalanceSmsTest({
        phone: p,
        house_name: String(houseName || '').trim(),
        room_fang: String(roomFang || '').trim(),
        template_code: String(templateCode || '').trim(),
        sign_name: String(signName || '').trim(),
      });
      setResult(res?.data || null);
      if (res?.success) {
        message.success(res.msg || '短信已提交');
        await loadToday(p, res?.data?.biz_id);
      } else {
        message.error(res?.msg || '发送失败');
      }
    } catch (e) {
      setResult(e.response?.data?.data || null);
      message.error(e.response?.data?.msg || e.message || '发送失败');
    } finally {
      setSendLoading(false);
    }
  };

  return (
    <div>
      <PageTitle title="蓝牙低电量短信测试" />

      <Card title="发送测试短信（仅 fang）" size="small" style={{ marginBottom: 16, maxWidth: 720 }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text type="secondary">手机号</Text>
            <Input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="例如 13811111111"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房产名</Text>
            <Input
              value={houseName}
              onChange={(e) => setHouseName(e.target.value)}
              placeholder="请输入房产名"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房间号（原样传入，不转汉字）</Text>
            <Input
              value={roomFang}
              onChange={(e) => setRoomFang(e.target.value)}
              placeholder="例如 301 或 A301"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">短信模板 Code（可手填；留空读 sms_notify_template_code_ble）</Text>
            <Input
              value={templateCode}
              onChange={(e) => setTemplateCode(e.target.value)}
              placeholder="SMS_xxxxxxxx"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">短信签名（可手填；留空读 sms_notify_sign_name）</Text>
            <Input
              value={signName}
              onChange={(e) => setSignName(e.target.value)}
              placeholder="例如 某某科技"
              disabled={sendLoading}
            />
          </div>
          <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 12 }}>
            预览 fang：{previewFang(houseName, roomFang)}
          </Paragraph>
          <Space wrap>
            <Button type="primary" loading={sendLoading} onClick={sendTest}>
              发送蓝牙低电量短信
            </Button>
            <Button loading={queryLoading} onClick={() => loadToday()}>
              查询今日送达
            </Button>
            <Button loading={queryLoading} onClick={() => loadToday(undefined, '')}>
              查询今日全部（不限 BizId）
            </Button>
          </Space>
        </Space>
      </Card>

      {result ? (
        <Card title="最近一次提交结果（不等于已收到）" size="small" style={{ marginBottom: 16, maxWidth: 720 }}>
          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item label="手机号">{result.phone || '—'}</Descriptions.Item>
            <Descriptions.Item label="fang">{result.fang || '—'}</Descriptions.Item>
            <Descriptions.Item label="签名">{result.sign_name || '—'}</Descriptions.Item>
            <Descriptions.Item label="模板">{result.template_code || '—'}</Descriptions.Item>
            <Descriptions.Item label="BizId">{result.biz_id || '—'}</Descriptions.Item>
            <Descriptions.Item label="RequestId">{result.request_id || '—'}</Descriptions.Item>
            <Descriptions.Item label="Code">{result.code || '—'}</Descriptions.Item>
            <Descriptions.Item label="Message">{result.message || '—'}</Descriptions.Item>
          </Descriptions>
        </Card>
      ) : null}

      <Card title="今日送达回执（阿里云 QuerySendDetails）" size="small" style={{ maxWidth: 1100 }}>
        {queryMsg ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 8, fontSize: 12 }}>
            {queryMsg}
          </Text>
        ) : null}
        {queryHint ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 12 }}>
            {queryHint}
          </Text>
        ) : null}
        <Table
          size="small"
          rowKey={(row) => `${row.seq}-${row.send_date}-${row.out_id || ''}-${row.template_code || ''}`}
          loading={queryLoading}
          dataSource={list}
          pagination={false}
          scroll={{ x: 980 }}
          locale={{ emptyText: queryLoading ? '查询中…' : '暂无记录，可先发送或稍后再查' }}
          columns={[
            { title: '序号', dataIndex: 'seq', width: 56 },
            { title: '发送时间', dataIndex: 'send_date', width: 160 },
            { title: '接收时间', dataIndex: 'receive_date', width: 160 },
            {
              title: '状态',
              dataIndex: 'status_label',
              width: 160,
              render: (text, row) => (
                <Tag color={smsStatusTagColor(row.status_key)} style={{ margin: 0, whiteSpace: 'normal' }}>
                  {text || '—'}
                </Tag>
              ),
            },
            { title: '原因说明', dataIndex: 'reason', ellipsis: true, width: 260 },
            { title: 'ErrCode', dataIndex: 'err_code', width: 120 },
            { title: '模板', dataIndex: 'template_code', width: 140 },
            { title: '内容', dataIndex: 'content', ellipsis: true },
          ]}
        />
      </Card>
    </div>
  );
};

export default BluetoothLowBalanceSmsTest;
